<template>
  <div>
    {{ value }}
  </div>
</template>

<script>
import { TipoProduto } from 'px-business-components';

export default {
  props: {
    tipoProduto: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  created() {
    if (!this.tipoProduto) {
      return;
    }
    this.value = TipoProduto.keys[this.tipoProduto].description;
  },
};
</script>
